import { ObjectState } from '../../../cross-team-shared/annotation/shared/state/object-state';
import { ShapeState } from '../../../cross-team-shared/annotation/shared/state/shape-state';

export interface ShapeGroupForCopyPaste {
  groupType: string;
  shapes: ShapeState[];
}

export interface CopyPasteMeta {
  isForSingleFrame: boolean;
  dataType: '2D' | '3D' | 'Annotation';
}

export interface ClipboardShapeDataObjectless {
  meta: CopyPasteMeta;
  shapesOrGroups: ShapeOrGroupForCopyPaste[];
}

export interface ClipboardAnnotationData {
  meta: CopyPasteMeta;
  shapes: ShapeState[];
  objects: ObjectState[];
}

export type ShapeOrGroupForCopyPaste = ShapeState | ShapeGroupForCopyPaste;

export function isShapeGroupForCopyPaste(
  shapeOrGroup: ShapeOrGroupForCopyPaste,
): shapeOrGroup is ShapeGroupForCopyPaste {
  return shapeOrGroup.hasOwnProperty('groupType');
}
